export enum DrawType {
  Point = 'Point',
  Polygon = 'Polygon',
  LineString = 'LineString',
  MultiPoint = 'MultiPoint',
  Rectangle = 'Rectangle',
  MultiLineString = 'MultiLineString',
  MultiPolygon = 'MultiPolygon',
  Circle = 'Circle'
}
